import BotConditionCard from "./BotConditionCard";
import React from "react";
import {useWatch} from "react-hook-form";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import CountryMultiSelect from "../../campaigns/conditions/CountryMultiSelect";
import {Box, Button, IconButton} from "@mui/material";
import {Add, Delete} from "@mui/icons-material";

function BotConditionGeo(props) {
    // 1. Get controllers from top form
    const {control, setValue, getValues} = props;

    // 2. Watch the live rules layout
    const rules = useWatch({control, name: "rules"}) || {};
    const countryData = rules?.country;
    const hasCountryCondition = !!countryData;

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    // 3. REMOVE: Pure JS delete
    const removeCondition = () => {
        const currentRules = {...getValues("rules")};
        delete currentRules.country;
        setValue("rules", currentRules);
    };

    // 4. ADD: Set native default layout
    const addCondition = () => {
        setValue("rules.country", {
            condition: "is",
            includeEmptyValue: false,
            values: []
        });
    };

    const renderAddCondition = () => {
        if (!hasCountryCondition) {
            return (
                <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                        <span>Country</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            onClick={addCondition}
                            sx={{textTransform: "none", py: 0.25, px: 1}}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        if (hasCountryCondition) {
            return (
                <>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                        <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                            Country
                        </Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size="small"
                                onClick={removeCondition}
                                sx={{color: 'error.dark'}}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            control={control}
                            options={radioConditions}
                            name="rules.country.condition"
                            label="conditions"
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name="rules.country.includeEmptyValue"
                        />
                    </Box>
                    <Box sx={{mt: 1}}>
                        <CountryMultiSelect
                            control={control}
                            inputName="rules.country.values"
                            inputLabel="Select countries"
                            outputKey="code"
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <BotConditionCard>
            {renderAddCondition()}
            {renderConditionBox()}
        </BotConditionCard>
    );
}

export default BotConditionGeo;
